module.exports = __webpack_public_path__ + "static/img/xg2.08afb142.png";